import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { RegistrationStatusProvider } from '../contexts';
import { useRegistrationStatusInitialState } from '../hooks';

export const RegisterStatusContainer: FC<PropsWithChildren> = ({ children }) => {
  const { finished, setFinished } = useRegistrationStatusInitialState();

  useEffect(() => {
    setFinished(finished);
  }, [finished, setFinished]);

  return (
    <RegistrationStatusProvider
      value={{
        finished,
        setFinished,
      }}
    >
      {children}
    </RegistrationStatusProvider>
  );
};
